"use client";

import clsx from "clsx";
import Link from "next/link";
import React from "react";
import { useClerk } from "@clerk/nextjs";
import { clickSignupCta, openSignup } from "@/helpers/signupTracking";

interface PasswordlessSignUpProps {
  className?: string;
  secondaryLabel?: string;
  secondaryLink?: string;
}

const PasswordlessSignUp = ({
  className,
  secondaryLabel = "Book a demo",
  secondaryLink = "/book-a-demo",
}: PasswordlessSignUpProps) => {
  const clerk = useClerk();
  const [emailAddress, setEmailAddress] = React.useState("");

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    clickSignupCta("cta");
    openSignup({ page_path: window.location.pathname });
    // Clerk queues this call if its client is still loading.
    clerk.openSignUp({
      initialValues: { emailAddress },
      forceRedirectUrl: "https://app.dash0.com",
      fallbackRedirectUrl: "https://app.dash0.com",
    });
  };

  return (
    <div
      className={clsx(
        [
          "passwordless-form text-center z-20 pt-8 relative w-full lg:w-[435px] flex flex-col gap-3 mx-auto justify-self-center",
        ],
        className
      )}
    >
      <form
        onSubmit={handleOnSubmit}
        className="dash0-website-passwordless-signup-form-cta items-center flex-row!"
      >
        <input
          type="email"
          name="email"
          value={emailAddress}
          autoComplete="on"
          placeholder="Email Address"
          onChange={(e) => setEmailAddress(e.target.value)}
          required
          className="bg-[#18181B]! border border-[#49494C] rounded-lg! min-h-[50px] placeholder:text-grey-550!"
        />
        <button
          className="absolute right-1 rounded h-10 items-center text-center px-4 leading-none group font-medium bg-[#FD8C66] hover:bg-[#F8494D] transition-colors duration-1000 shrink-0"
          type="submit"
        >
          <span className="relative z-10 whitespace-nowrap">
            Start for free
          </span>
          <div className="absolute pointer-events-none inset-0 overflow-hidden rounded">
            <div className="animate-random-bubble gradient-bubble absolute" />
          </div>
        </button>
      </form>
      <p className="text-grey-550 text-sm ">
        Start for free or{" "}
        <Link className="text-white underline" href={secondaryLink}>
          {secondaryLabel}
        </Link>
      </p>
    </div>
  );
};

export default PasswordlessSignUp;
